/**
 *
 * @param {String} string
 * @param {Boolean} bool
 * @returns a string with a S on end
 */

export const pluralize = (string, bool) => (bool ? `${string}s` : string)

export const isLink = href => /^((https?:)?\/\/|[0-9a-zA-Z]+:)/.test(href || '')

export const formatNumber = value => value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
